import React from 'react';
import I18n from '@/modules/i18n';
import { Button } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';

type Rating = 'positive' | 'negative' | null;

interface QualityFeedbackProps {
  className?: string;
  disabled?: boolean;
  rating: Rating;
  onRate: (rating: 'positive' | 'negative') => void;
}

const QualityFeedback = ({ className, disabled = false, rating, onRate }: QualityFeedbackProps) => (
  <div className={cn('tw-flex tw-items-center tw-gap-1.5', className)}>
    <span className="tw-text-sm tw-text-tci-black">
      {I18n.t('ai_quality_feedback_label')}
    </span>
    <Button
      small
      aria-pressed={rating === 'positive'}
      className="tw-h-[26px] tw-w-[37px] !tw-p-0 tw-flex tw-items-center tw-justify-center"
      disabled={disabled}
      label={I18n.t('ai_quality_feedback_thumbs_up')}
      outlineStyle={rating !== 'positive'}
      onClick={() => onRate('positive')}
    >
      <Icon icon="ThumbUp" size={16} />
    </Button>
    <Button
      small
      aria-pressed={rating === 'negative'}
      className="tw-h-[26px] tw-w-[37px] !tw-p-0 tw-flex tw-items-center tw-justify-center"
      disabled={disabled}
      label={I18n.t('ai_quality_feedback_thumbs_down')}
      outlineStyle={rating !== 'negative'}
      onClick={() => onRate('negative')}
    >
      <Icon icon="ThumbDown" size={16} />
    </Button>
  </div>
);

export type { Rating };
export default QualityFeedback;
